import { render, staticRenderFns } from "./sectionDetail.vue?vue&type=template&id=7581322d&scoped=true"
import script from "./sectionDetail.vue?vue&type=script&lang=js"
export * from "./sectionDetail.vue?vue&type=script&lang=js"
import style0 from "./sectionDetail.vue?vue&type=style&index=0&id=7581322d&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7581322d",
  null
  
)

export default component.exports